
import React, { useState, useMemo } from 'react';
import { useAuth } from '../AuthContext';
import { useChat } from '../ChatContext';
import { Page, PageContextType } from '../types';
import { isUserOnline } from '../utils';
// FIX: Changed import to correct PageContext file to avoid circular dependency
import { PageContext } from '../PageContext';

interface NewMessageModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const NewMessageModal: React.FC<NewMessageModalProps> = ({ isOpen, onClose }) => {
    const { userProfile, allUsers } = useAuth();
    const { getOrCreateConversation } = useChat();
    const pageContext = React.useContext(PageContext);
    const [searchTerm, setSearchTerm] = useState('');

    const friends = useMemo(() => {
        if (!userProfile) return [];
        return allUsers.filter(u => userProfile.following.includes(u.uid) && userProfile.followers.includes(u.uid));
    }, [userProfile, allUsers]);

    const filteredFriends = useMemo(() => {
        if (!searchTerm) return friends;
        return friends.filter(f => f.displayName.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [searchTerm, friends]);

    const handleUserClick = (user: any) => {
        getOrCreateConversation(user.uid);
        pageContext?.switchPage(Page.ChatConversation, user.displayName, { recipient: user });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center p-4 pt-16" onClick={onClose}>
            <div className="bg-[var(--primary-dark-purple)] text-white rounded-lg shadow-xl w-full max-w-sm flex flex-col h-[70vh] border border-white/20" onClick={e => e.stopPropagation()}>
                <h2 className="text-xl font-bold p-4 border-b border-white/20 aurora-text">New Message</h2>
                <div className="p-4 flex flex-col flex-grow min-h-0">
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search for a friend..."
                        className="w-full border-white/20 rounded-md shadow-sm bg-white/10 text-white focus:ring-[var(--accent-pink)] focus:border-[var(--accent-pink)] placeholder-gray-400 p-2 mb-4"
                    />
                    <div className="overflow-y-auto flex-grow">
                        {filteredFriends.length > 0 ? (
                            filteredFriends.map(friend => (
                                <div key={friend.uid} onClick={() => handleUserClick(friend)} className="flex items-center p-2 space-x-3 hover:bg-white/10 rounded-lg cursor-pointer">
                                    <div className="relative flex-shrink-0">
                                        <img src={friend.photoURL} alt={friend.displayName} className="w-10 h-10 rounded-full object-cover" />
                                        {isUserOnline(friend) && (
                                            <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-500 border-2 border-[var(--primary-dark-purple)]"></span>
                                        )}
                                    </div>
                                    <p className="font-semibold text-white">{friend.displayName}</p>
                                </div>
                            ))
                        ) : (
                             <p className="text-center text-gray-400 pt-8">No friends found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewMessageModal;
